import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutPageComponent } from './components/layout-page/layout-page.component';
import { AdminModule } from '../admin/admin.module';
import { HomeModule } from '../home/home.module';
const routes: Routes = [
  {
    path: '',
    component: LayoutPageComponent,
    data: { title: 'StartupTN-Catalyst' },
    children: [
      {
        path: '',
        loadChildren: '../home/home.module#HomeModule',
        data: { title: '' },
      },
      {
        path: 'admin',
        loadChildren: '../admin/admin.module#AdminModule',
        data: { title: '' },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [HomeModule, AdminModule],
})
export class LayoutRoutingModule {}
